import React from "react";
import Hero from "./sections/hero/Hero";
import FeaturedSlider from "./sections/slider/FeaturedSlider";
import Technology from "./sections/tech/Technology";
import CardsSection from "./sections/cardsSection/CardsSection";
import Journey from "./sections/journey/Journey";
import Resources from "../../common/resources/Resources";

const Home = () => {
  return (
    <>
      <Hero />
      <FeaturedSlider />
      <Technology />
      <CardsSection />
      <Journey />
      <Resources homePage={true} />
    </>
  );
};

export default Home;
